import { useNotification } from 'components/Notification'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  lockCustomerAuthorization,
  unlockCustomerAuthorization,
} from 'services/customerAuthorizations'
import { CUSTOMER_AUTHORIZATION_QUERY_KEY } from '../constants'

const useCustomerAuthorizationMutation = ({ customerId }) => {
  const { createNotification } = useNotification()
  const queryClient = useQueryClient()

  const createErrorNotification = err => {
    const detailedErrMessage = err.response.data.errors[0]
    createNotification({
      message: `Something went wrong: ${detailedErrMessage}`,
      variant: 'error',
    })
  }

  const removeCustomerAuthorization = useMutation({
    mutationFn: lockCustomerAuthorization,
    onSuccess: () => {
      createNotification({ message: 'User removed from customer', variant: 'success' })
      queryClient.invalidateQueries({
        queryKey: [CUSTOMER_AUTHORIZATION_QUERY_KEY, customerId],
      })
    },
    onError: createErrorNotification,
  })

  const restoreCustomerAuthorization = useMutation({
    mutationFn: unlockCustomerAuthorization,
    onSuccess: () => {
      createNotification({ message: 'User restored to customer', variant: 'success' })
      queryClient.invalidateQueries({
        queryKey: [CUSTOMER_AUTHORIZATION_QUERY_KEY, customerId],
      })
    },
    onError: createErrorNotification,
  })

  return {
    removeCustomerAuthorization,
    restoreCustomerAuthorization,
  }
}

export default useCustomerAuthorizationMutation
